import React from 'react'
import { StaticRouter } from 'react-router'
import { BrowserRouter } from 'react-router-dom'
import { Layout } from '@polystack/admin/src/utils/Renderer'
import { uistore } from '@polystack/admin/src/store/uistore'
import Container from 'component-index/Container'
import Navigation from 'component-index/Navigation'
import PageContent from 'component-index/PageContent'

const Routah = typeof window === 'undefined' ? StaticRouter : BrowserRouter

class Renderer extends React.Component {
  rootPath = ''

  render () {
    let { store, layout, navigation, theme, rootPath, location} = this.props
    if(!location) {
      location = navigation?.routes[0]?.route
    }
    return (
      <Routah location={location}>
        <Layout store={store} layout={layout} routes={navigation?.routes || []} theme={theme} />
      </Routah>
    )
  }
}

export default Renderer
